// dependencies
import React from "react";
import { List } from "immutable";
import { getTime } from "date-fns";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// components
import buildGraphs from "./Graphs";

// actions
import { updateRequestsRange } from "../../actions";

// selectors
import { getRequestsPerMinute, getMeanResponseTime, getGraphWidth } from "../../selectors";

// css
import css from "./TimeSeries";

class TimeSeries extends React.PureComponent {
	static propTypes = {
		updateRequestsRange: PropTypes.func.isRequired,
		graphWidth: PropTypes.number.isRequired,
		requestsPerMinute: PropTypes.instanceOf(List).isRequired,
		meanResponseTime: PropTypes.instanceOf(List).isRequired,
	};

	constructor(props) {
		super(props);

		this.svgContainer = React.createRef();
	}

	componentDidMount = () => {};

	componentDidUpdate = () => {
		const { graphWidth, requestsPerMinute, meanResponseTime } = this.props;

		const checks = [graphWidth > 0, meanResponseTime.size > 0, requestsPerMinute.size > 0];

		if (checks.filter((value) => !value).length === 0) {
			buildGraphs(
				this.svgContainer.current,
				{ requestsPerMinute, responseTimes: meanResponseTime },
				this.handleSelect
			);
		}
	};

	handleSelect = (range) => {
		if (range === null) {
			this.props.updateRequestsRange(null);
			return;
		}

		const lowerBoundary = getTime(range[0]) / 1000;
		const upperBoundary = getTime(range[1]) / 1000;

		this.props.updateRequestsRange(lowerBoundary, upperBoundary);
	};

	render = () => {
		return (
			<div className={css.SVGContainer}>
				<div className={css.legendContainer}>
					<div className={`${css.legendItem} ${css.requestType}`}>
						<div className={css.legendColor} />
						<div className={css.legendLabel}>Requests Count</div>
					</div>

					<div className={`${css.legendItem} ${css.meanResponseTimeType}`}>
						<div className={css.legendColor} />
						<div className={css.legendLabel}>Mean Response Time</div>
					</div>

					<div className={`${css.legendItem} ${css.maxResponseTimeType}`}>
						<div className={css.legendColor} />
						<div className={css.legendLabel}>Max Response Time</div>
					</div>

					<div className={`${css.legendItem} ${css.uniqueUsersType}`}>
						<div className={css.legendColor} />
						<div className={css.legendLabel}>Unique Users</div>
					</div>
				</div>

				<div ref={this.svgContainer} />
			</div>
		);
	};
}

const mapStateToProps = (state) => ({
	graphWidth: getGraphWidth(state),
	requestsPerMinute: getRequestsPerMinute(state),
	meanResponseTime: getMeanResponseTime(state),
});

const mapDispatchToProps = (dispatch) => ({
	updateRequestsRange: (lowerBoundary, upperBoundary) => dispatch(updateRequestsRange(lowerBoundary, upperBoundary)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TimeSeries);
